import {InternalAxiosRequestConfig} from "axios";

export const authInterceptor = (config: InternalAxiosRequestConfig, clientId: string): InternalAxiosRequestConfig => {
    const savedToken = window.localStorage.getItem(`tn.oidc.${clientId}.idToken`);
    const authToken: string = savedToken === null ? '' : JSON.parse(savedToken) as string;
    config.headers.set('Authorization', `Bearer ${authToken}`);
    return config;
};